// https://gist.github.com/mathewbyrne/1280286
export default function (text = '', disallowNonWordChar = true) {
  let slugifyText = text.toString().toLowerCase()
    .replace(/\s+/g, '-'); // Replace spaces with -

  let hasNonWordChar = new RegExp(/[^\w\-]+/g).test(slugifyText);

  if (disallowNonWordChar) {
    slugifyText = slugifyText.replace(/[^\w\-]+/g, '');       // Remove all non-word chars
  }

  slugifyText = slugifyText
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text

  if (hasNonWordChar) {
    console.warn(`Slugify: The text "${text}" contains non-word characters. They have ${disallowNonWordChar ? '' : 'not'} been removed. Result: "${slugifyText}"`);
  }

  return slugifyText;
}
